const GITHUB_COLOR_TOKEN = {
  GRAY: 'caption',
  RED: 'red',
  ORANGE: 'orange',
  YELLOW: 'yellow',
  GREEN: 'green',
  BLUE: 'blue',
  PURPLE: 'purple',
  PINK: 'magenta'
}

export const githubColorTokenFromName = (color) => GITHUB_COLOR_TOKEN[color] || 'caption'
